import { useEffect, useState } from 'react'

/**
 * Returns `false` on the server and during the client's first render, then
 * `true` after the component has mounted. Gate any value that legitimately
 * differs between server and client — current time / relative time, the
 * browser timezone, `window`/`navigator`, `localStorage` — behind this so the
 * first render matches the server and the real value is applied post-mount.
 * Prevents React hydration mismatches (error #425).
 */
export default function useMounted(): boolean {
  const [ mounted, setMounted ] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  return mounted
}
